<template>
<div class="page page_order page_order_detail">
    <!-- 物流信息 -->
    <div class="wuliu" v-if="afterSale!=1&&orderDetail.ship_status == 1">
        <div class="wuliu_t">物流信息</div>
        <div class="wuliu_item clearfix" v-for="logistics in orderDetail.logistics" :key="logistics.time">
            <div class="wuliu_item_l f-l">{{ logistics.time }}</div>
            <div class="wuliu_item_r f-l">{{ logistics.description }}</div>
        </div>
        <!-- <div class="wuliu_item clearfix">
            <div class="wuliu_item_l f-l">2020-03-21 20:07</div>
            <div class="wuliu_item_r f-l">河北省衡水市桃城区山木枝有限公司</div>
        </div> -->
    </div>
    <!-- 地址区域 -->
    <div class="item" v-if="afterSale!=1">
        <div class="adress">
            <div class="info">
                <div class="user">{{ orderDetail.receipt_name + ' ' + orderDetail.receipt_phone }}</div>
                <div class="dizhi">
                    {{ orderDetail.receipt_address }}
                </div>
            </div>
        </div>
    </div>
    <!-- 订单商品信息 -->
    <div class="list">
        <div class="item">
            <div class="item_t">
                <div class="item_t_t">
                    <img v-if="orderDetail.tradesman" :src="orderDetail.tradesman.thumb? ($publicData.withHttpStart(orderDetail.tradesman.thumb) ? orderDetail.tradesman.thumb : imageUrl+orderDetail.tradesman.thumb) :$publicData.defaultTouxiang" alt="" class="thumb" @click="toTradsman" />
                    <div class="title">{{ (orderDetail.tradesman!=null&&orderDetail.tradesman.nickname!=null)?orderDetail.tradesman.nickname:'' }}</div>
                </div>
                <div v-if="afterSale!=1" class="status">{{ orderDetail.statusTitle }}</div>
                <!-- <div v-if="afterSale==1" class="status" >售后中</div> -->
            </div>
            <div class="item_nr" v-for="goods in orderDetail.order_good" :key="goods.order_good_id">
                <div class="item_nr_l" @click="toGoodsDetail(goods)">
                    <img :src="goods.thumb ? imageUrl+goods.thumb : $publicData.intangibleDefault" alt="" class="tu" />
                </div>
                <div class="item_nr_r">
                    <div class="item_nr_r_t" @click="toGoodsDetail(goods)">
                        <div class="title slh">
                            {{ goods.title }}
                        </div>
                        <div class="info">
                            <span class="price"><span class="tag_cash">¥</span>{{ goods.price }}</span>
                            <span class="nums">x{{ goods.num }}</span>
                        </div>
                    </div>
                    <div class="sku" @click="toGoodsDetail(goods)">{{ goods.spec_name }}</div>
                    <div class="actions">
                        <!-- <div v-if="!goods.return_good_info&&orderDetail.receipt_status==1" class="action" @click="goTuiKuan(goods)" >申请退换</div> -->
                        <!-- <div  v-if="!goods.return_good_info&&orderDetail.receipt_status==1&&goods.comment_status==0" class="action" @click="goComment(goods)">评价</div> -->
                        <div v-if="!goods.return_good_info&&orderDetail.receipt_status==1&&goods.comment_status==1" class="action">已评价</div>
                        <!-- <div v-if="goods.return_good_info" class="action" @click="returnClick(goods)">{{goods.return_good_info.status==0?'退货申请':(goods.return_good_info.status==1?'退款成功':'退款失败')}}</div> -->
                    </div>
                </div>
            </div>
            <div class="item_extra">
                <div class="item_extra_l">邮费</div>
                <div class="item_extra_r">{{ orderDetail.fare }}</div>
            </div>
            <div class="item_extra" v-if="discount && discount != 0">
                <div class="item_extra_l">折扣</div>
                <div class="item_extra_r">{{ dazhe }}</div>
            </div>
            <div class="item_extra">
                <div class="item_extra_l">实付款</div>
                <div class="item_extra_r">
                    <div class="price"><span class="cash_tag">¥</span>{{ orderDetail.total_prices }}</div>
                </div>
            </div>
        </div>
        <!-- 订单信息 -->
        <div class="item item_order">
            <div class="title">订单信息</div>
            <div class="order">
                <div class="">订单编号:{{ orderDetail.order_num }}</div>
                <div class="">父订单编号:{{ orderDetail.pay_order_num }}</div>
                <div class="">创建时间:{{ orderDetail.created_at }}</div>
                <div class="">付款时间:{{ orderDetail.pay_at }}</div>
				<!-- 资金是否到账 -->
				<!-- <div class="">资金是否到账:{{ orderDetail.wxreturn_status }}</div> -->
            </div>
        </div>
        <!-- 操作 -->
        <div class="actions">
            <div class="action" v-if="role != 1">联系匠人</div>
            <div class="action" v-if="showClose" @click="show_cancel = true">关闭订单</div>
            <div class="action" v-if="showSend" @click="showFahuo_overlay = true">发货</div>
			<!-- <div class="action" v-if="showSend" @click="sendOrderTips">发货</div> -->
            <!-- <div class="action" v-if="showReturn" @click="retrunOrder">退换货</div> -->
            <!-- <div class="action" v-if="orderDetail.order_status!=0&&orderDetail.pay_status==0" @click="toPay">付款</div>
            <div class="action" v-if="orderDetail.order_status!=0&&this.orderDetail.ship_status!=1" @click="cancelOrder">取消订单</div>
            <div class="action" v-if="orderDetail.order_status!=0&&orderDetail.ship_status==1&&orderDetail.receipt_status==0 && type != 1 && role!=1" @click="clickReceipt">收货</div>
<div class="action" v-if="orderDetail.order_status!=0&&orderDetail.ship_status==1&&orderDetail.receipt_status==0 && type==1" @click="show_overlay = true">提货码</div> -->
        </div>
        <!-- 提货码 -->
        <van-overlay :show="show_overlay" @click="show_overlay = false" />
        <div class="custom_info" v-if="show_overlay">
            <div class="info_top">
                <div class="info_title">提货凭证</div>
                <img :src="publicPath+'statics/images/close_item.png'" alt="" class="info_close" @click="show_overlay = false">
            </div>
            <div class="info_nr" v-if="orderDetail.zt">
                <div class="tu_wrap">
                    <img :src="publicPath+'statics/images/ziti_bg.png'" alt="" class="tu">
                </div>
                <div class="num_wrap">
                    <div class="num_title">提货码</div>
                    <div class="nums">{{orderDetail.zt.tihuocode}}</div>
                </div>
                <div class="text">
                    <div class="text_info">
                        <div class="text_info_l">提货手机：</div>
                        <div class="text_info_r">{{orderDetail.zt.phone}}</div>
                    </div>
                    <div class="text_info zitidian">
                        <div class="text_info_l">自提点：</div>
                        <div class="text_info_r">{{orderDetail.zt.name}}</div>
                    </div>
                    <div class="text_info address">
                        <div class="text_info_l">提货地址：</div>
                        <div class="text_info_r">{{ orderDetail.zt.address }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 发货 -->
        <van-overlay :show="showFahuo_overlay" @click="showFahuo_overlay = false" />
        <div class="custom_info fahuo" v-if="showFahuo_overlay">
            <div class="info_top">
                <div class="info_title">发货</div>
                <img :src="publicPath+'statics/images/close_item.png'" alt="" class="info_close" @click="showFahuo_overlay = false">
            </div>
            <div class="info_nr">
                <div class="text">
                    <div class="text_info">
                        <div class="text_info_l">订单号：</div>
                        <div class="text_info_r">{{orderDetail.order_num}}</div>
                    </div>
                    <div class="text_info">
                        <div class="text_info_l">快递公司：</div>
                        <div class="text_info_r" @click="kuaidi_picker=true">
                            <van-field v-model="logistics_name" placeholder="请选择快递公司" readonly />
                        </div>
                    </div>
                    <div class="text_info">
                        <div class="text_info_l">快递单号：</div>
                        <div class="text_info_r">
                            <van-field v-model="logistics_code" placeholder="请填写快递单号" />
                        </div>
                    </div>
                    <div class="text_info">
                        <div class="text_info_l">店家备注：</div>
                        <div class="text_info_r">
                            <van-field v-model="shop_mark" placeholder="选填备注" />
                        </div>
                    </div>
					<div class="btn" @click="sendOrder">确认发货</div>
                </div>
            </div>
        </div>
        <!-- 快递列表 -->
        <van-popup v-model="kuaidi_picker" position="bottom">
            <van-picker title="选择快递" show-toolbar :columns="logisticsList" value-key="name" @confirm="confirmKuaidi" @cancel="kuaidi_picker=false" />
        </van-popup>
		<!-- 关闭订单确认框 -->
		<div class="page_set" v-if="show_cancel">
			<!-- 样式同 page_set -->
			<van-dialog v-model="show_cancel" title="确定关闭订单吗？" show-cancel-button @cancel="show_cancel = false" @confirm="closeOrder">
			</van-dialog>
		</div>
    </div>
	<!-- 发货提示风险框,弃用-不会出现这种情况 -->
	<!-- <van-dialog v-model="show_risk_tips" title="风险提示" message="资金未到账,是否确认发货？" show-cancel-button @cancel="show_risk_tips = false" @confirm="showFahuo_overlay = true">
	</van-dialog> -->
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            imageUrl: Vue.prototype.$publicData.uploadImage,
            orderId: this.$route.query.orderId,
            afterSale: this.$route.query.afterSale, // 是否售后
            orderDetail: {},
            token: null,
            type: this.$route.query.type, // 1自提订单, 默认普通订单
            show_overlay: false, // 遮罩层状态
            role: this.$route.query.role, // 1 商家角色, 0 普通角色
            showClose: false,
            showSend: false,
            showReturn: false,
            discount: null, // 折扣
            dazhe: null, // 打几折
            showFahuo_overlay: false, // 发货弹层
            logistics_name: null,
            logistics_code: null,
            shop_mark: null,
			logisticsList: null, // 快递列表
			kuaidi_picker: false,
			show_cancel: false ,// 关闭订单确认框
            is_platprice: this.$route.query.is_platprice //0匠人 1供应商 2园区
			// show_risk_tips: false // 风险提示,弃用,不会出现这种情况
        };
    },
    created: function () {

    },
    mounted: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '订单详情',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                    this.getKuaidiList()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.getData()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.getData();
            this.getKuaidiList()
        }
        
    },
    methods: {
        // 获取列表
        getData() {
            // is_platprice: this.$route.query.is_platprice //0匠人 1供应商 2园区
            var type = 1
            switch (this.is_platprice) {
                case 0:
                    type = 2
                    break;
                case 1:
                    type = 1
                    break;
                case 2:
                    type = 3
                    break;            
                default:
                    break;
            }
            var params = {
                token: this.token,
                order_id: this.orderId,
                type: type // 匠人查看订单
            }
            this.$api.shop.orderDetail(params).then(res => {
                if (res.code == 200) {
                    this.orderDetail = res.result
                    this.showClose = false
                    this.showSend = false
                    // 折扣
                    this.discount = res.result.discount
                    var discount = res.result.discount
                    if (discount && discount != 0) {
                        var discount = discount.toString()
                        var zhe = ''
                        if (discount.length == 1) {
                            zhe = discount / 10 + '折'
                        } else if (discount.length > 1) {
                            if (discount[discount.length - 1] == 0) {
                                zhe = discount / 10 + '折'
                            } else {
                                zhe = discount + '折'
                            }
                        }
                        this.dazhe = zhe
                    }
                    // 订单状态
                    if (this.orderDetail.order_status == 0) {
                        this.orderDetail.statusTitle = '已取消'
                    } else if (this.orderDetail.receipt_status == 1) {
                        this.orderDetail.statusTitle = '交易成功'
                    } else {
                        if (this.orderDetail.ship_status == 1) {
                            this.orderDetail.statusTitle = this.type == 1 ? '待提货' : '等待收货'
                        } else {
                            if (this.orderDetail.pay_status == 0) {
                                this.showClose = true
                                this.orderDetail.statusTitle = '等待付款'
                            } else if (this.orderDetail.pay_status == 1) {
                                this.showClose = true
                                this.orderDetail.statusTitle = '等待付款'
                            } else if (this.orderDetail.pay_status == 2) {
                                this.orderDetail.statusTitle = '等待发货'
                                this.showSend = true
                                this.showClose = true
                            }
                        }
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //申请退货
        returnClick(goods) {
            if (goods.return_good_info.status == 0) { //申请退货

            }
        },
        //关闭订单
        closeOrder() {
            var params = {
                token: this.token,
                order_id: this.orderDetail.order_id,
			}
            this.$api.tradesman.closeOrder(params).then(res => {
                if (res.code == 200) {
					this.$toast('关闭订单成功')
					this.show_cancel = false
                    this.getData()
                } else {
					this.$toast(res.message)
					this.show_cancel = false
                }
            })
        },
        //点击头像进入匠人详情页
        toTradsman() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + this.orderDetail.tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: this.orderDetail.tradesman.id
                    }
                })
            }
        },
        //点击商品进入商品详情页
        toGoodsDetail(goods) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + goods.good_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/shop/detail",
                    query: {
                        goodsId: goods.good_id,
                    },
                });
            }
        },
        //收货
        clickReceipt() {
            var params = {
                token: this.token,
                order_id: this.orderId
            }
            this.$api.shop.confirmOrder(params).then(res => {
                if (res.code == 200) {
                    this.$toast('确认收货成功')
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 评论
        goComment(goods) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?orderId=" + this.orderDetail.order_id + '&goodsId=' + goods.good_id
                // + '&title=' + encodeURIComponent(goods.title) + '&price=' + goods.total_prices + '&count=' + goods.num + '&spec=' + encodeURIComponent(goods.spec_name) + '&image=' + goods.thumb
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/order/comment' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/order/comment',
                    query: {
                        orderId: this.orderDetail.order_id,
                        goodsId: goods.good_id,
                        // title: goods.title,
                        // price: goods.total_prices,
                        // count: goods.num,
                        // spec: goods.spec_name,
                        // image: goods.thumb
                    }
                })
            }
        },
        toPay() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?orderId=" + this.orderDetail.pay_order_num + '&price=' + this.orderDetail.total_prices
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/pay' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/pay',
                    query: {
                        orderId: this.orderDetail.pay_order_num,
                        price: this.orderDetail.total_prices,
                        isPlatprice: this.orderDetail.is_platprice
                    }
                })
            }

        },
        cancelOrder() {
            var params = {
                token: this.token,
                order_id: this.orderId
            }
            this.$api.shop.cancelOrder(params).then(res => {
                if (res.code == 200) {
                    this.$toast('取消订单成功')
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 提货码
        clickZiti() {
            console.log('提货码')
        },
        // 获取快递公司列表
        getKuaidiList() {
            var params = {
                token: this.token,
                page: 1,
                size: 100
            }
            this.$api.tradesman.kuaidiList(params).then(res => {
                if (res.code == 200) {
                    this.logisticsList = res.result.list
                }
            })
		},
		// 选快递公司
		confirmKuaidi(value){
			this.logistics_name = value.name
			this.kuaidi_picker = false
		},
		// 确认发货
		sendOrder(){
			if(!this.logistics_name){
				this.$toast('请选择快递公司')
				return
			}
			if(!this.logistics_code){
				this.$toast('请填写快递单号')
				return
			}
			var params = {
				token: this.token,
				order_id: this.orderDetail.order_id,
				logistics_code: this.logistics_code,
				logistics_name: this.logistics_name
			}
			if(this.shop_mark){
				params.shop_mark = this.shop_mark
			}
			// console.log('发货',params)
			this.$api.tradesman.fahuo(params).then(res=>{
				if(res.code == 200){
					this.$toast('发货成功')
					this.showFahuo_overlay = false
					this.getData()
				}else{
					this.$toast(res.message)
					this.showFahuo_overlay = false
				}
			})
		},
		// 确认发货提示 -- 融宝没返回成功,提示发货有风险,弃用,不会出现这种情况
		// sendOrderTips(){
		// 	var order = this.orderDetail
		// 	if(order.wxreturn_status != 3081){
		// 		this.show_risk_tips = true
		// 	}else{
		// 		this.showFahuo_overlay = true
		// 	}
		// }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-cell {
    background: none;
}

/deep/.van-cell .van-field__control {
    padding: 0;
    color: rgba(0, 0, 0, .87);

}

/deep/.van-cell .van-field__control {
	height: auto;
	line-height: .6rem;
}
.page_set{
	height: auto;
}
</style>
